/* =========================================================
   Galerie derulabila — pagina de lansare a seriei 18.

   Derularea manuala e nativa: scroll-snap din CSS, deget pe telefon,
   rotita pe desktop. Scriptul adauga sagetile, derularea automata si
   butonul care o opreste.

   Derularea automata se opreste singura cand: clientul o opreste din
   buton, trece cu mouse-ul peste galerie, intra cu tastatura in ea,
   incepe sa deruleze cu degetul, galeria iese din ecran, sau sistemul
   cere miscare redusa. Se reia de unde a ramas.
   ========================================================= */
(function () {
  'use strict';

  var MISCARE_REDUSA = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function itemi(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.i18gal__item'));
  }

  /* Cat trebuie sa fie scrollLeft ca elementul sa stea fix pe marginea
     din stanga a benzii. Masurat direct, nu calculat din latimi si
     spatii — asa nu se aduna erori de rotunjire. */
  function pozitia(track, item) {
    return item.getBoundingClientRect().left
         - track.getBoundingClientRect().left
         + track.scrollLeft;
  }

  function pas(track) {
    var lista = itemi(track);
    if (lista.length < 2) return track.clientWidth;
    var p = pozitia(track, lista[1]) - pozitia(track, lista[0]);
    if (!isFinite(p) || p <= 0) return track.clientWidth || 300;
    return p;
  }

  function laCapat(track) {
    return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  function actualizeazaSageti(root, track) {
    var btns = root.querySelectorAll('[data-i18-dir]');
    if (!btns.length) return;

    var laInceput = track.scrollLeft <= 1;
    var sfarsit = laCapat(track);

    for (var i = 0; i < btns.length; i += 1) {
      var dir = parseInt(btns[i].getAttribute('data-i18-dir'), 10);
      btns[i].disabled = dir < 0 ? laInceput : sfarsit;
    }
  }

  /* ---------- buline ---------- */

  /* O bulina = o latime de banda. Nu depinde de cate imagini se vad
     odata, deci merge la fel pe desktop, tableta si telefon. */
  function nrPagini(track) {
    var w = track.clientWidth;
    if (!w) return 1;
    return Math.max(1, Math.ceil(track.scrollWidth / w));
  }

  function construiesteDots(root, track) {
    var wrap = root.querySelector('[data-i18-dots]');
    if (!wrap) return;

    var n = nrPagini(track);
    if (wrap.childElementCount === n) return;

    var eticheta = wrap.getAttribute('data-label') || 'Grupul';
    wrap.innerHTML = '';
    for (var i = 0; i < n; i += 1) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'i18gal__dot';
      b.setAttribute('data-i18-dot', i);
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', eticheta + ' ' + (i + 1));
      wrap.appendChild(b);
    }
  }

  function actualizeazaDots(root, track) {
    var wrap = root.querySelector('[data-i18-dots]');
    if (!wrap || !wrap.children.length) return;

    var w = track.clientWidth || 1;
    var activ = Math.round(track.scrollLeft / w);

    for (var i = 0; i < wrap.children.length; i += 1) {
      var on = i === activ;
      wrap.children[i].classList.toggle('is-active', on);
      wrap.children[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
  }

  function muta(track, dir) {
    track.scrollBy({ left: dir * pas(track), behavior: 'smooth' });
  }

  /* ---------- derularea automata ---------- */

  function Auto(track, secunde) {
    this.track = track;
    this.ms = Math.max(1, secunde) * 1000;
    this.timer = null;
    this.oprit = false;      /* oprit de client, din buton */
    this.suspendat = false;  /* pauza temporara: mouse, focus, ecran */
  }

  Auto.prototype.tick = function () {
    /* la capat o luam de la inceput, ca sa fie bucla, nu fundatura */
    if (laCapat(this.track)) {
      this.track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      muta(this.track, 1);
    }
  };

  Auto.prototype.porneste = function () {
    if (this.timer || this.oprit || this.suspendat || MISCARE_REDUSA) return;
    var self = this;
    this.timer = window.setInterval(function () { self.tick(); }, this.ms);
  };

  Auto.prototype.stai = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  Auto.prototype.suspenda = function (da) {
    this.suspendat = da;
    if (da) { this.stai(); } else { this.porneste(); }
  };

  Auto.prototype.comuta = function () {
    this.oprit = !this.oprit;
    if (this.oprit) { this.stai(); } else { this.porneste(); }
    return !this.oprit;
  };

  function etichetaButon(btn, ruleaza) {
    var text = btn.getAttribute(ruleaza ? 'data-label-pause' : 'data-label-play');
    if (text) btn.textContent = text;
    btn.setAttribute('aria-pressed', ruleaza ? 'true' : 'false');
    btn.classList.toggle('is-running', ruleaza);
  }

  function legaAuto(root, track) {
    var secunde = parseFloat(root.getAttribute('data-i18-autoplay'));
    if (!isFinite(secunde) || secunde <= 0) return;

    var auto = new Auto(track, secunde);
    var btn = root.querySelector('[data-i18-toggle]');

    if (btn) {
      etichetaButon(btn, !MISCARE_REDUSA);
      btn.addEventListener('click', function () {
        etichetaButon(btn, auto.comuta());
      });
    }

    if (root.getAttribute('data-i18-pause-hover') === 'true') {
      root.addEventListener('mouseenter', function () { auto.suspenda(true); });
      root.addEventListener('mouseleave', function () { auto.suspenda(false); });
    }

    /* cine navigheaza cu tastatura sau incepe sa traga cu degetul
       vrea control, nu sa i se miste imaginile sub mana */
    root.addEventListener('focusin', function () { auto.suspenda(true); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) auto.suspenda(false);
    });
    track.addEventListener('pointerdown', function () { auto.suspenda(true); });
    track.addEventListener('pointerup', function () { auto.suspenda(false); });

    /* nu are rost sa mearga cand galeria nu e pe ecran */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (intrari) {
        auto.suspenda(!intrari[0].isIntersecting);
      }, { threshold: 0.2 }).observe(root);
    } else {
      auto.porneste();
    }
  }

  /* ---------- pornire ---------- */

  function init(root) {
    if (root.dataset.i18GalReady === '1') return;
    root.dataset.i18GalReady = '1';

    var track = root.querySelector('[data-i18-track]');
    if (!track) return;

    root.addEventListener('click', function (ev) {
      var sageata = ev.target.closest('[data-i18-dir]');
      if (sageata && root.contains(sageata)) {
        muta(track, parseInt(sageata.getAttribute('data-i18-dir'), 10) || 1);
        return;
      }

      var bulina = ev.target.closest('[data-i18-dot]');
      if (bulina && root.contains(bulina)) {
        var i = parseInt(bulina.getAttribute('data-i18-dot'), 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
    });

    var pending = false;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        actualizeazaSageti(root, track);
        actualizeazaDots(root, track);
      });
    });

    window.addEventListener('resize', function () {
      actualizeazaSageti(root, track);
      construiesteDots(root, track);
      actualizeazaDots(root, track);
    });

    /* imaginile se incarca lazy, deci latimea totala creste dupa randare */
    var imgs = track.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) {
      imgs[i].addEventListener('load', function () {
        actualizeazaSageti(root, track);
        construiesteDots(root, track);
        actualizeazaDots(root, track);
      });
    }

    actualizeazaSageti(root, track);
    construiesteDots(root, track);
    actualizeazaDots(root, track);
    legaAuto(root, track);
  }

  function scan() {
    var roots = document.querySelectorAll('[data-i18-gallery]');
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
